import { useState, useEffect } from "react";
import { decode } from "universal-base64";
import clsx from "clsx";

import {
  Plate,
  createPlateUI,
  createAlignPlugin,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
  ELEMENT_LI,
  createPlugins,
  createParagraphPlugin,
  createBlockquotePlugin,
  createTodoListPlugin,
  createHeadingPlugin,
  createImagePlugin,
  createHorizontalRulePlugin,
  createLinkPlugin,
  createListPlugin,
  createTablePlugin,
  createMediaEmbedPlugin,
  createCodeBlockPlugin,
  createBoldPlugin,
  createCodePlugin,
  createItalicPlugin,
  createHighlightPlugin,
  createUnderlinePlugin,
  createStrikethroughPlugin,
  createSubscriptPlugin,
  createSuperscriptPlugin,
  createFontBackgroundColorPlugin,
  createFontColorPlugin,
  createFontSizePlugin,
  createFontWeightPlugin,
  createKbdPlugin,
  createNodeIdPlugin,
  createComboboxPlugin,
  createMentionPlugin,
  createDeserializeMdPlugin,
  createDeserializeCsvPlugin,
  createDeserializeDocxPlugin,
  // createJuicePlugin,
  createFontFamilyPlugin,
  createIndentPlugin,
  getPlateActions,
} from "@udecode/plate";

function EditorReadOnly({ docId, value }) {
  const [initialState, setInitialState] = useState();
  const { resetEditor } = getPlateActions(docId);
  let components = createPlateUI();

  const plugins = createPlugins(
    [
      createParagraphPlugin(),
      createBlockquotePlugin(),
      createTodoListPlugin(),
      createHeadingPlugin(),
      createImagePlugin(),
      createHorizontalRulePlugin(),
      createLinkPlugin(),
      createListPlugin(),
      createTablePlugin(),
      createMediaEmbedPlugin(),
      createCodeBlockPlugin(),
      createBoldPlugin(),
      createCodePlugin(),
      createItalicPlugin(),
      createHighlightPlugin(),
      createUnderlinePlugin(),
      createStrikethroughPlugin(),
      createSubscriptPlugin(),
      createSuperscriptPlugin(),
      createFontBackgroundColorPlugin(),
      createFontFamilyPlugin(),
      createFontColorPlugin(),
      createFontSizePlugin(),
      createFontWeightPlugin(),
      createKbdPlugin(),
      createNodeIdPlugin(),
      createComboboxPlugin(),
      createMentionPlugin(),
      createDeserializeMdPlugin(),
      createDeserializeCsvPlugin(),
      createDeserializeDocxPlugin(),
      // createJuicePlugin(),
      createAlignPlugin({
        inject: {
          props: {
            validTypes: [
              ELEMENT_PARAGRAPH,
              ELEMENT_H1,
              ELEMENT_H2,
              ELEMENT_H3,
              ELEMENT_H4,
              ELEMENT_H5,
              ELEMENT_H6,
            ],
          },
        },
      }),
      createIndentPlugin({
        inject: {
          props: {
            validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_LI],
          },
        },
      }),
    ],
    {
      components,
    }
  );

  const editableProps = {
    placeholder: "Type…",
    style: {
      padding: "2px",
    },
    readOnly: true,
  };

  useEffect(() => {
    if (value) {
      try {
        const decoded = decode(value);
        setInitialState(JSON.parse(decoded));
      } catch (error) {
        const slateValue = JSON.parse(value);
        if (Array.isArray(slateValue)) {
          setInitialState(slateValue);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (initialState) {
      setTimeout(() => {
        resetEditor();
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState]);

  return (
    <div
      // className="prose-sm 2xl:prose-lg max-w-none prose-hr:border-t prose-hr:border-black/80 prose-hr:!border-solid prose-td:!border-l-2 prose-td:!border-t-2 prose-td:!border-black/30 prose-tr:!border-r-2 prose-tr:!border-black/30 prose-table:!border-b-2 prose-table:!border-black/30"
      className={clsx(
        "max-w-none",
        "prose 2xl:prose-lg",
        "prose-p:!py-0",
        "prose-figure:m-0",
        "prose-hr:border-t prose-hr:border-black/80 prose-hr:!border-solid",
        "prose-table:!table-auto",
        "prose-table:!border prose-table:!border-black",
        "prose-tr:!border-y prose-tr:!border-black",
        "prose-td:!border-x prose-td:!border-black"
      )}
    >
      <Plate
        id={docId}
        editableProps={editableProps}
        plugins={plugins}
        initialValue={initialState}
      />
    </div>
  );
}

export default EditorReadOnly;
